export const HELP_URL = 'https://help.diritto.co.kr';

export const POLICY_URL = 'https://www.diritto.co.kr/help/policy';
export const PRIVACY_URL = 'https://www.diritto.co.kr/help/privacy';
export const OPEN_SOURCE_LICENSE_URL = 'https://www.diritto.co.kr/help/open-source-license';

export const YOUTH_URL = 'https://policy.ridi.com/legal/youth/';
export const DIRITTO_STUDIO_SURVEY = 'https://14nid3x2nun.typeform.com/to/D5tdBOzv';

export const TWITTER_URL = 'https://twitter.com';

export const CONTENT_HELP_URL = {
  ABROAD_CERT: `${HELP_URL}/hc/ko/requests/new?ticket_form_id=8755829875471`,
  FANCY_SHARE_URL: `${HELP_URL}/hc/ko/articles/8820316265359-이미지로-멋지게-공유하기`,
  HIDDEN_CONTENTS: `${HELP_URL}/hc/ko/articles/8831246544655-작품-정보-작품-내용-숨기기-예약`,
  PROPOSAL_CONTENTS: `${HELP_URL}/hc/ko/articles/9530982418831-작품-정보-출판사-계약-의지-밝히기`,
  MARKETING_AGREED: `${HELP_URL}/hc/ko/articles/8831335084687-새-작품-작품-마케팅-활용-동의`,
  DIRITTO_ONLY: `${HELP_URL}/hc/ko/articles/8831247619215-작품-정보-디리토-ONLY`,
  DIRITTO_STUDIO: `${HELP_URL}/hc/ko/sections/8803774457359-디리토-스튜디오`,
  COMMUNITY_GUIDE_LINE: `${HELP_URL}/hc/ko/articles/8854823402255-커뮤니티-가이드라인`,
  CONTEST_S3: `${HELP_URL}/hc/ko/articles/8854823402255-커뮤니티-가이드라인`,
};

export const PARTNER_TYPEFORM_URL = 'https://14nid3x2nun.typeform.com/to/tHVyjldM';
